const { getAxiosInstance } = require('../connection');

module.exports = {
    report: function (reports) {
        return getAxiosInstance({
            url: `/collect`,
            method: 'post',
            json: true,
            data: reports,
        }).then((r) => r.data);
    },
};
